var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"trigger":"click","height":_vm.bannerHeight+'px',"arrow":"hover"}},_vm._l((_vm.images),function(item){return _c('el-carousel-item',{key:item.url},[_c('el-image',{ref:"bannerHeight",refInFor:true,staticClass:"image",attrs:{"placeholder":"图片加载中。。。","src":item.url}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }